import { processSteps } from '../../data/services';
import { container, eyebrow, h2Section } from '../../lib/ui';
import { Icon } from '../Icon';

/** "The 4-Step Execution Trajectory" — used on /services and every service page. */
export function ProcessSection() {
  return (
    <section className="w-full py-space-xl md:py-20 bg-surface-cream relative overflow-hidden" id="process">
      <div className={`${container} relative z-10`}>
        <div className="reveal text-center max-w-2xl mx-auto mb-space-xl">
          <span className={`${eyebrow} block mb-space-xs`}>Our Uncompromising Process</span>
          <h2 className={h2Section}>The 4-Step Execution Trajectory</h2>
          <p className="font-body-md text-body-md text-on-surface-variant mt-space-xs">
            Rigorous engineering discipline coupled with artisanal sensibility, guaranteeing predictability from initial
            survey to final keys.
          </p>
        </div>
        <div className="relative">
        <div aria-hidden="true" className="hidden lg:block absolute top-12 left-12 right-12 h-[2px] bg-gold-light/60 z-0" />
        <ol className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-gutter relative">
          {processSteps.map((step, i) => (
            <li
              key={step.number}
              className="reveal group relative z-10 flex flex-col p-space-md bg-surface-ivory rounded-xl shadow-sm hover:shadow-xl hover:-translate-y-1 transition-all duration-300"
            >
              <div className="flex items-center justify-between mb-space-md">
                <div
                  className={`w-14 h-14 rounded-full flex items-center justify-center font-headline-sm text-headline-sm transition-all ${
                    i === 0
                      ? 'bg-primary text-gold-light group-hover:scale-110'
                      : 'bg-surface-container text-primary group-hover:bg-primary group-hover:text-gold-light'
                  }`}
                >
                  {step.number}
                </div>
                <span className="font-label-sm text-label-sm uppercase tracking-wider text-secondary">{step.phase}</span>
              </div>
              <h3 className="font-headline-sm text-headline-sm text-primary mb-2">{step.title}</h3>
              <p className="font-body-sm text-body-sm text-on-surface-variant leading-relaxed">{step.text}</p>
              <div className="mt-auto pt-4">
                <div className="bg-surface-cream/50 p-2 rounded font-body-sm text-body-sm text-on-surface">
                  <span className="font-label-sm text-label-sm uppercase tracking-wider text-secondary block">
                    Milestone Output
                  </span>
                  {step.output}
                </div>
              </div>
            </li>
          ))}
        </ol>
        </div>
        <div className="reveal mt-space-lg p-space-md bg-surface-ivory rounded-xl shadow-sm flex flex-col sm:flex-row items-start sm:items-center justify-between gap-space-md">
          <div className="flex items-center gap-space-sm">
            <Icon name="verified_user" size={26} className="text-primary" />
            <div>
              <p className="font-headline-sm text-headline-sm text-primary">Zero Structural Surprises</p>
              <p className="font-body-sm text-body-sm text-on-surface-variant">
                Every dimension is fixed before civil contractors initiate works on site.
              </p>
            </div>
          </div>
          <div className="flex items-center gap-3">
            <div className="w-32 bg-surface-container rounded-full h-2.5 overflow-hidden shrink-0" aria-hidden="true">
              <div className="bg-primary h-2.5 rounded-full w-full" />
            </div>
            <span className="font-label-md text-label-md uppercase tracking-wider text-primary font-bold">
              Guaranteed Milestone Adherence
            </span>
          </div>
        </div>
      </div>
    </section>
  );
}
